export default __webpack_public_path__ + "static/media/user-regular.27e7608e.svg";